import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { resolveSaqFormDictionary } from "../../../../../dictionaries/saq/saq_dictionary_registry";

type SaqSectionDictionary = Record<string, SaqSectionDetails>;

interface SaqFormSection {
    requirements?: SaqSectionDictionary;
}

type SaqFormDictionary = Record<string, SaqFormSection>;

interface SaqSectionDetails {
    section_subtitle?: string;
}

const DEFAULT_SECTION_ID = "section_2b";
@Component({
    selector: "tr[appSaqSectionSubtitleHeader]",
    templateUrl: "./section_subtitle.component.html",
    styleUrls: ["./section_subtitle.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionSubtitleHeaderComponent {
    @Input({ required: true }) public sectionKey!: string;

    private currentSectionId = DEFAULT_SECTION_ID;
    private saqFormDictionary: SaqFormDictionary = resolveSaqFormDictionary(null);

    @Input()
    public set sectionId(value: string | undefined) {
        this.currentSectionId = this.normalizeSectionId(value);
    }

    @Input()
    public set formType(value: string | null) {
        this.saqFormDictionary = resolveSaqFormDictionary(value);
        this.currentSectionId = this.normalizeSectionId(this.currentSectionId);
    }

    public get subtitleText(): string {
        const requirements = this.getSectionRequirements(this.currentSectionId);
        return requirements[this.sectionKey]?.section_subtitle ?? "";
    }

    private normalizeSectionId(sectionId: string | undefined): string {
        if (!sectionId) {
            return DEFAULT_SECTION_ID;
        }

        const normalized = sectionId.trim();
        if (normalized.length === 0) {
            return DEFAULT_SECTION_ID;
        }

        return this.saqFormDictionary[normalized] ? normalized : DEFAULT_SECTION_ID;
    }

    private getSectionRequirements(sectionId: string): SaqSectionDictionary {
        const candidate = this.saqFormDictionary[sectionId]?.requirements;
        if (candidate && typeof candidate === "object") {
            return candidate;
        }

        const fallback = this.saqFormDictionary[DEFAULT_SECTION_ID]?.requirements;
        return fallback && typeof fallback === "object" ? fallback : {};
    }
}
